import { Navigate, useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { useEffect } from 'react';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import EmployeerPage from './pages/EmployeerPage';
import EmployPage from './pages/EmployPage';
import AdminPage from './pages/AdminPage';
import Employeestatic from './pages/Employeestatic';
import Ticketspage from './pages/Ticketspage';
import Commentpage from './pages/Commentpage';
import Transactionpage from './pages/Transactionpage';

// ----------------------------------------------------------------------

export default function Router() {
  const token = localStorage.getItem('authToken');
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate('/login');
    } else {
      navigate(`${pathname}`);
    }
  }, [token]);

  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'employer', element: <EmployeerPage /> },
        { path: 'employee', element: <EmployPage /> },
        { path: 'employeestatic', element: <Employeestatic /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'admin', element: <AdminPage /> },
        { path: 'ticket', element: <Ticketspage /> },
        { path: 'ticket/:userId', element: <Ticketspage /> },
        { path: 'comment/:userid/:ticketid', element: <Commentpage /> },
        { path: 'transaction', element: <Transactionpage /> },
        { path: 'transaction/:userId', element: <Transactionpage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
